import React from "react";
import { Tooltip } from "antd";

const colors = {
  initial: {
    color: "#9199A6",
    border: "1px solid #9199A6",
    background: "#F5F5F5",
  },
  finish: {
    color: "#1EA31E",
    border: "1px solid #32CD32",
    background: "#E8F8E8",
  },
  error: {
    color: "#FF0000",
    border: "1px solid #FF4D4F",
    background: "#FFFFFF",
  },
  analysis: {
    color: "#000C3E",
    border: "1px solid #000C3E",
    background: "#FFFFFF",
  },
  pending: {
    color: "#FF9800",
    border: "1px solid #FF9800",
    background: "#FFFFFF",
  },
};

const StatusBadge = ({ type = "initial", status = "", tooltipTextList = [] }) => {

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        padding: "6px 12px",
        borderRadius: 4,
        border: colors[type].border,
        color: colors[type].color,
        backgroundColor: colors[type].background,
        fontSize: 12,
        fontWeight: 600,
        textTransform: "uppercase",
        whiteSpace: "nowrap",
      }}
    >
      <span>{status}</span>

      {tooltipTextList && tooltipTextList.length > 0 && (
        <Tooltip
          placement="top"
          overlayStyle={{ maxWidth: 1000 }}
          title={
            <div>
              {tooltipTextList?.map((item, index) => (
                <div key={index}>
                  • {item}
                </div>
              ))}
            </div>
          }
        >
          <span
            style={{
              width: 16,
              height: 16,
              borderRadius: "50%",
              border: "1px solid currentColor",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 10,
              fontWeight: 700,
              cursor: "pointer",
              userSelect: "none",
            }}
          >
            ?
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export { StatusBadge };